import './about.css';
import headshot from '../images/ravid-headshot.jpg';

export default function About() {
  return (
    <div className="about-page-container">
      <div className="header-rate-day">
        <h1>Welcome to the Journaly app</h1>

        <p>
          Welcome to the Jounaly app! This app is designed to help you track
          your day. You can track your mood throught the day. Track the weather,
          how was your day on the social side. You can also add free text to
          what was your highlight of the day.
        </p>

        <p>Click on the links in the navigation bar to get started!</p>
        <h3 className="data-handling">Data Protection & Handling</h3>

        <p>
          The data that is saved is all yours, I don't have access to any of
          your entries, I cannot see it. The data is saved on your internet
          browser, whether you use Safari, or Chrome, mobile or desktop, the
          data is saved and stored on your internet browser.
          <br />
          Therefore, if you delete your cookies, or delete your browser data,
          the data on this website will also be removed and cannot be restored.
        </p>
        <h3>I'm Ravid</h3>
        <div>
          <img className="headshot" src={headshot} />
        </div>
        <div className="about-me">
          <p>
            I created this app after my GF asked for a digital version of the
            mood tracker analog style she saw on Instagram. <br />I made this
            app for fun, to practice my coding skills and to keep me occupied.
            This was a fun process, and I hope you use it.
          </p>

          <p>
            If you liked this web app, feel free to share it with your friends.
          </p>
          <p>
            Lastly, if you love this app, and you have some cash to spare, use
            the <b>"Buy me a coffee"</b> link at the bottom, so I can keep
            maintaining this web app.
          </p>
        </div>
      </div>
    </div>
  );
}
